export const sortProducts = (products, field_sorting) =>
  products.sort((a, b) =>
    Object.entries(field_sorting)
      .map(([field, sortingFunc]) => sortingFunc(a[field], b[field]))
      .reduce((prev, curr) => (prev ? prev : curr))
  );
